import React__default, { useState } from 'react';
import { Modal } from './Modal.es.js';
import { uid } from '../../helpers/utils.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const initialState = {};
const ModalStateContext = React__default.createContext(initialState);
const ModalProvider = ({
  children
}) => {
  const [configModals, setConfigModals] = useState([]);
  const showModal = (options) => {
    const _a = options, { onCancel: baseOnCancel, onOk: baseOnOk } = _a, rest = __objRest(_a, ["onCancel", "onOk"]);
    const modalId = uid();
    const onClose = () => {
      setConfigModals((prev) => {
        const newConfigs = prev.map((m) => {
          if (m.modalId === modalId)
            return __spreadProps(__spreadValues({}, m), { visible: false });
          return m;
        });
        if (newConfigs.every((m) => !m.visible))
          return [];
        return newConfigs;
      });
    };
    const onCancel = () => {
      baseOnCancel == null ? void 0 : baseOnCancel();
      onClose();
    };
    const onOk = async () => {
      await (baseOnOk == null ? void 0 : baseOnOk());
      onClose();
    };
    setConfigModals((prev) => [
      ...prev,
      __spreadValues({
        modalId,
        visible: true,
        onClose,
        onCancel,
        onOk
      }, rest)
    ]);
    return modalId;
  };
  const closeAllModals = () => {
    setConfigModals([]);
  };
  return /* @__PURE__ */ React__default.createElement(ModalStateContext.Provider, {
    value: {
      showModal,
      closeAllModals
    }
  }, children, configModals.map((modal) => /* @__PURE__ */ React__default.createElement(Modal, __spreadValues({
    key: modal.modalId
  }, modal))));
};

export { ModalProvider, ModalStateContext };
